import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';

// Sidebar standalone component
import { NgEmaSidebarComponent } from './shared/ui/sidebar/sidebar.component';

import { Observable } from 'rxjs';
import { GlobalPage } from './studioema/global.model';
import { environment } from 'src/environments/environment';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RouterOutlet,
    // Material
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    // Shared
    NgEmaSidebarComponent
  ]
})
export class AppComponent implements OnInit {
  version = '';
  envName = '';

  @ViewChild('snav') mobileSidenav: any;

  globalPage$!: Observable<GlobalPage>;
  global: GlobalPage = { darkMode: false, isMobile: false };

  ngOnInit(): void {
    this.version = environment.version;
    this.envName = environment.envName;

    // Simulated async global page observable (replace with actual service later)
    this.globalPage$ = new Observable<GlobalPage>((observer) => {
      setTimeout(() => {
        observer.next({ darkMode: false, isMobile: false });
        observer.complete();
      }, 500);
    });

    this.globalPage$.subscribe(data => this.global = data);
  }
}
